export const partners = [
  { id: 1, imageUrl: '/ooden_logo.png' },
  { id: 2, imageUrl: '/ooden_logo.png' },
  { id: 3, imageUrl: '/ooden_logo.png' },
  { id: 4, imageUrl: '/ooden_logo.png' },
];
